import React, { useEffect, useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import dash_api from '../../main/support/dash_api';
import getUnsubsctibeAlertNotificationUrl from '../../common/support/utils/getUnsubsctibeAlertNotificationUrl';
import { ImageService } from '../../main/services/ImageService/ImageService';

type SubscriptionStatus = 'UNSUBSCRIBED' | 'SUBSCRIBED' | 'ERROR';

export const ScreenUnsubscribedAlertNotification = () => {
  const { alertId, emailAddress, token } = useParams<any>();
  const [unsubscriptionStatus, setUnsubscriptionStatus] = useState<SubscriptionStatus>('SUBSCRIBED');

  useEffect(() => {
    const unsubsctibeAlertNotificationUrl = getUnsubsctibeAlertNotificationUrl(alertId, emailAddress, token);

    dash_api
      .delete(unsubsctibeAlertNotificationUrl)
      .then((response) => {
        const subscriptionStatus = response?.status === 200 ? 'UNSUBSCRIBED' : 'ERROR';
        setUnsubscriptionStatus(subscriptionStatus);
      })
      .catch(() => {
        setUnsubscriptionStatus('ERROR');
      });
  }, []);

  const getUnsubscribeResultMessage = useCallback(() => {
    if (unsubscriptionStatus === 'UNSUBSCRIBED') {
      return 'You are not subscribed to this alert anymore and will no longer receive emails';
    } else if (unsubscriptionStatus === 'ERROR') {
      return 'Cannot unsubscribe. Please try again';
    }

    return 'Unsubscribing in progress...';
  }, [unsubscriptionStatus]);

  return (
    <div className="loggedout--container">
      <img src={ImageService.getImageUrl('/static/images/branch-logos/branch-logo_dark.svg')} />
      <div className="h1 unsubscribe-header">{getUnsubscribeResultMessage()}</div>
    </div>
  );
};

export default ScreenUnsubscribedAlertNotification;
